var render = function render(_c,_vm){return _c('div',{},[_vm._v(" #"+_vm._s(_vm.props.order.orderNum)+" - "+_vm._s(_vm.props.order.customer.name)+" "),_c('br'),_vm._v(" "+_vm._s(_vm.props.order.orderStatus)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }